import { AbstractModel } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { RideLimitPeriod } from './ride-limit-period';

@inheritSerialization(AbstractModel)
export class OrganizationRiderPool extends AbstractModel {
  @autoserialize
  organizationId!: number;

  @autoserialize
  code!: string;

  @autoserializeAs(RideLimitPeriod)
  rideLimitPeriod!: RideLimitPeriod;

  @autoserialize
  rideLimit!: number;

  @autoserialize
  isRideLimitExternal!: boolean;
}
